import { CoreDispatch } from '../../store/CoreStore';

export enum PopupType {
  AutoplayModified = 'AutoplayModified',
  AutoplayStopped = 'AutoplayStopped',
  ConnectionLost = 'ConnectionLost',
  CustomPopup = 'CustomPopup',
  DontLeaveRoundInProgress = 'DontLeaveRoundInProgress',
  ExitConfirmation = 'ExitConfirmation',
  GenericError = 'GenericError',
  GenericErrorNoRefresh = 'GenericErrorNoRefresh',
  SessionExpired = 'SessionExpired',
  Inactivity = 'Inactivity',
  InsufficientFunds = 'InsufficientFunds',
  LoggedOut = 'LoggedOut',
  NicknameEnter = 'NicknameEnter',
  RealityCheck = 'RealityCheck',
  Reconnecting = 'Reconnecting',
  SessionBalance = 'SessionBalance',
  TableClosed = 'TableClosed',
  PrivateTableOccupied = 'PrivateTableOccupied',
  VipTableLowBalance = 'VipTableLowBalance',
  VideoIsDisabled = 'VideoIsDisabled',
  VideoStreamQuality = 'VideoStreamQuality',
  SessionBalanceError = 'SessionBalanceError',
  Error = 'Error',
  ByInvitation = 'ByInvitation',
  DuplicatePrivatePlayerSession = 'DuplicatPrivatePlayerSession',
  BeforeInactivity = 'BeforeInactivity',
  SessionTerminated = 'SessionTerminated',
}

export enum ErrorToastType {
  BET_NOT_ON_TIME = 'NOT_ON_TIME_ERROR',
  BET_NOT_ALLOWED = 'SAFE_BETS_ERROR',
  PLAYER_LIMIT_REACHED = 'ERROR_20610',
  BETS_REJECTED = 'BETS_REJECTED',
  NOT_ALL_BETS_ACCEPTED = 'NOT_ALL_BETS_ACCEPTED',
}

export type OnCloseCallback = (dispatch: CoreDispatch) => void;
